import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TextArea.scss';

export default class TextArea extends Component {
  render () {
    const { props } = this;
    const errorMsg = props.errors && props.errors[props.name];
    return (
      <div className={'textarea-container ' + props.className}>
        <label>{props.label}</label>
        {errorMsg && errorMsg.length > 0 && (<span className='error'>{errorMsg}</span>)}
        <textarea name={props.name} onChange={props.onHandleChange} rows={props.rows} value={props.value}/>
      </div>
    );
  }
}

TextArea.propTypes = {
  label: PropTypes.string,
  errors: PropTypes.object,
  name: PropTypes.string,
  value: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string,
  onHandleChange: PropTypes.func
};
